const isFirebaseAuthError = (obj) => {
    const authError = obj;
    return authError.code !== undefined && authError.message !== undefined;
};
export default isFirebaseAuthError;
